import type { FaireProductEntity } from "../../entity_types/product";

export const p_us7sfgef4e: FaireProductEntity = {
  token: "p_us7sfgef4e",
  type: "product",
  name: "Thanks Little Notes®",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/a88c6ed65d050dd939d660887080935acf21c5e4bbad68a3f0c50b1e0f304f74.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ce1653b90bc434c04d34232f1a3ddbc77cfd27bdcc541e9bc378d13c06de7664.jpeg",
    "https://cdn.faire.com/fastly/0a0b325f5922a7d2c1e4fd13898fa44b58551774a7b6772a6daf63d4c178227b.jpeg",
    "https://cdn.faire.com/fastly/5940713f59a36d11a6432ff619f77fe66af491d69c55388fe0fba911c1ecff5e.jpeg",
    "https://cdn.faire.com/fastly/90619d575d1f1a13a19d1cb3c2da25593612f8d7b3446fad4067f773cc668f60.png",
  ],
  priceDollars: 7,
  description:
    "Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a reminder that someone is seen. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes have already been shared worldwide, sparking connection one small gesture at a time.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:51.920Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
